module.exports = __webpack_public_path__ + "static/media/18ECA15.cf57eb53.jpg";